import {
  Divider,
  Grid,
  Box,
  Typography,
  Chip,
  Link,
  Tooltip,
  TextField,
  FormControl,
  GridSize,
} from '@material-ui/core';
import { OverlayContainer, Overlay } from '@components/overlay';
import { SectionTitle, useCompanyFormState } from '../common';
import BallotRoundedIcon from '@material-ui/icons/BallotRounded';
import { indigo } from '@material-ui/core/colors';
import { map } from 'rxjs/operators';
import { CompanyBasicFormField, CompanyLogoField } from '../fields';
import { useFormContext, useWatch, useController } from 'react-hook-form';
import React, { useEffect, useCallback, useMemo, useRef, useState } from 'react';
import { Observable, Subscription } from 'rxjs';
import LaunchIcon from '@material-ui/icons/Launch';
import { useRecentGetter, vtrUrl } from '@lib/common';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';
import { EntityType } from '@lib/deals';
import { debounce } from 'lodash';
import { HelperTextTip } from '@components/hepler-text-tip';
import { useInsightActions } from '../service-insights';
import { useSubject } from '@lib/common/hooks/use-subject';
import MovieCreationIcon from '@material-ui/icons/MovieCreation';
import OfflinePinIcon from '@material-ui/icons/OfflinePin';
import { Autocomplete } from '@material-ui/lab';
import { useSubscription } from '@lib/common/hooks/use-subscription';
import { debounceTime, filter } from 'rxjs/operators';
import * as personService from '@api/person';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import LockClosedIcon from '@material-ui/icons/Lock';
import AddIcon from '@material-ui/icons/Add';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import { ColoredChip } from '@components/colored-elements';
import Fab from '@material-ui/core/Fab';
import styled from 'styled-components';
import * as userService from 'services/user';
import InputAdornment from '@material-ui/core/InputAdornment';
import { AiOutlineExpandAlt, AiOutlineShrink } from '@icon/react-icons';
import { VerifiedDetails } from './section-utils';
// const clickForMultipleTabs = href1 => {
//   window.open(href1);
// };

export const SectionBasicDetails = () => {
  const [sizeServiceDescription, setSizeServiceDescription] = useState(5);
  const { control } = useFormContext();
  const form = useFormContext();
  const { user } = userService.useUser();
  const { edit, company } = useCompanyFormState();

  /**
   * Setup events for the insighter.
   */
 // const { showDescriptionInsight } = useInsightActions();
  const descriptionObserver = useWatch({
    control,
    name: 'company_service_description',
    defaultValue: '',
  });
  const description$ = useSubject<string>();
  const [isLock, setLock] = useState<boolean>(
    (company &&
      company.verified_sections &&
      company.verified_sections.profile_section &&
      company.verified_sections.profile_section.verified) ||
      edit
  );
 // const state = useRecentGetter({ showDescriptionInsight });
/*   useEffect(() => description$.next(descriptionObserver), [descriptionObserver]);
  useSubscription(() =>
    description$
      .pipe(
        filter(txt => !!(txt && txt.trim())),
        debounceTime(500)
      )
      .subscribe(description => state().showDescriptionInsight({ description }))
  ); */
  const watchOnVerifiedSections = form.watch('verified_sections');
  const verifiedBy =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.profile_section &&
    watchOnVerifiedSections.profile_section.verified_by;
  const verifiedAt =
    watchOnVerifiedSections &&
    watchOnVerifiedSections.profile_section &&
    watchOnVerifiedSections.profile_section.verified_at + ' IST';
  return (
    <>
      <br />
      <SectionTitle
        title={
          <>
            Profile
            {edit && company && company.vtr_id && (
              <>
                {'  '}
                <Tooltip title="Visit Company">
                  <Chip
                    size="small"
                    component={Link}
                    target="_blank"
                    href={vtrUrl(company.vtr_id, EntityType.company)}
                    icon={<LaunchIcon />}
                    label={`ID: ${company.vtr_id}`}
                    clickable
                    color="primary"
                  />
                </Tooltip>
                {/* &nbsp;
                    <Tooltip title="Create Relation">
                      <Chip
                        size="small"
                        component={Link}
                        target="_blank"
                        href={vtrUrl(company.vtr_id, EntityType.company)}
                        icon={<AddCircleOutlineIcon />}
                        label={`Create Relation`}
                        clickable
                        color="secondary"
                      />
                    </Tooltip> */}
              </>
            )}
          </>
        }
        subTitle="Key details about the Company"
        id="basic-details"
        icon={<BallotRoundedIcon style={{ color: indigo[700] }} fontSize="large" />}
        fabIcons={
          <>
            {edit && company && company.vtr_id  && (
              <Tooltip title="Create Relation" style={{ marginRight: '5px' }}>
                <StyledFab
                  color="primary"
                  aria-label="add"
                  size="small"
                  href={`${window.location.origin}/company-content/new?company_vtr_id=${company.vtr_id}&company_name=${company.vtr_company_name}&isBeta=true`}>
                  <AddIcon />
                </StyledFab>
              </Tooltip>
            )}
            <Tooltip
              title={
                isLock ? (
                  <>
                    {`Verified by ${verifiedBy}`}
                    <br />
                    {`Verified at ${verifiedAt}`}
                  </>
                ) : (
                  'Click to Lock the Section'
                )
              }>
              {isLock ? (
                <StyledFab
                  color="primary"
                  aria-label="add"
                  size="small"
                  style={{ backgroundColor: 'green' }}
                  onClick={() => {
                    setLock(false);
                    form.setValue('verified_sections', {
                      ...form.watch('verified_sections'),
                      profile_section: { verified: false, verified_by: null, verified_at: null, isLockApplied: false },
                    });
                  }}>
                  <LockClosedIcon />
                </StyledFab>
              ) : (
                <StyledFab
                  color="primary"
                  aria-label="add"
                  size="small"
                  style={{ backgroundColor: 'red' }}
                  onClick={() => {
                    setLock(true);
                    form.setValue('verified_sections', {
                      ...form.watch('verified_sections'),
                      profile_section: {
                        verified: true,
                        verified_by: user.vtr_id,
                        verified_at: new Date().toLocaleString('en-US', { timeZone: 'IST' }),
                        isLockApplied: true,
                      },
                    });
                    // company.verified_sections.profile_section.verified_by = user.vtr_id;
                    // company.verified_sections.profile_section.verified = true;
                  }}>
                  <LockOpenIcon />
                </StyledFab>
              )}
            </Tooltip>
            {isLock && <VerifiedDetails verifiedBy={verifiedBy} verifiedAt={verifiedAt} />}
          </>
        }
      />{' '}
      <Divider />
      <br />
      {/* <OverlayContainer></OverlayContainer> */}
      <fieldset disabled={isLock && edit} style={{"border":"none"}}>
        <Grid container spacing={3}>
          {/* LEFT: LOGO */}
          <Grid item xs={12} md={2}>
            <Box display="flex" flexDirection="column" alignItems="center">
              <CompanyLogoField control={control} name="logo" />
              <Box mt={1}>
                <Typography align="center" variant="body2">
                  Edit Logo
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* RIGHT: BASIC DETAILS */}
          <Grid item xs={12} md={10}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <CompanyBasicFormField
                  name="vtr_company_name"
                  label="Name"
                  required
                  helperText={
                    <HelperTextTip
                      text="Name of the Company"
                      tip="[Tip: Check spelling, cases, spaces]"
                    />
                  }
                />
              </Grid>

              <Grid item xs={12} md={6} >
                <CompanyBasicFormField
                  name="company_display_name"
                  label="Display Name"
                  fullWidth
                  helperText={
                    <HelperTextTip text="Display name of the Company" />
                  }
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <CompanyBasicFormField
                  name="company_aka"
                  label="AKA"
                  fullWidth
                  size="small"
                  helperText={'"Also Known As" or other names that the company is referred as.'}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <CompanyBasicFormField
                  name="company_headline"
                  label="Headline"
                  fullWidth
                  helperText={<HelperTextTip text="Headline of the Company" />}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CompanyBasicFormField
                  name="company_keywords"
                  label="Keywords"
                  multiline
                  fullWidth
                  rowsMax={4}
                  rows={4}
                  helperText="Comma separated keywords describing services and offerings of the company."
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <CompanyBasicFormField
                  name="company_service_description"
                  label="Service Description"
                  multiline
                  fullWidth
                  rows={4}
                  helperText="Service description of the Company"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* 🔷 FULL WIDTH DESCRIPTION (FOCUS AREA) */}
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CompanyBasicFormField
              name="company_description"
              label="Description"
              multiline
              fullWidth
              rows={8}   // increased height
              helperText={
                <HelperTextTip
                  text="Overview of the Company"
                  tip="[Tip: Use sentence form; check grammar]"
                />
              }
            />
          </Grid>
        </Grid>

      </fieldset>
    </>
  );
};

/**
 * Create Styled Fab for new relation
 */
const StyledFab = styled(Fab)`
  &.MuiFab-sizeSmall {
    width: 40px;
    // background-color: red;
    // height: 30px;
  }
  & .MuiSvgIcon-root {
    font-size: 1.4rem;
  }
`;
